<template>
  <notifications position="top center" />
   <vue3-confirm-dialog></vue3-confirm-dialog>
  <router-view />
  <descriptionFooter></descriptionFooter>
</template>

<script>

import descriptionFooter from '@/components/footer/description-footer.vue'


export default {
  name: 'App',
  components: { descriptionFooter }
}
</script>

<style>
#app {
  font-family: "Montserrat", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #042F5F;
}
</style>
